import React, { useState } from "react";
import {
  makeStyles,
  ListItem,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
} from "@material-ui/core/";
import { Link } from "react-router-dom";
import { isValidPathUrl } from "../../../utils/general";
const useStyle = makeStyles((theme) => ({
  listItem: {
    fontSize: "1rem",
    color: "#005598 !important",
    textDecoration: "none",
  },
  mobilelistItem: {
    width: "100vh",
    fontSize: "1rem",
    color: "#005598 !important",
    textDecoration: "none",
  },
  ListItemRoot: {
    width: "auto",
    padding: "0 0.5rem",
  },
}));

const MenuItems = (props) => {
  const classes = useStyle(props);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, key, url) => {
    event.currentTarget.className += " active";
    setAnchorEl(event.currentTarget);
    path(url, key);
    if (props.view === "mobile") {
      if (
        key === "Events" ||
        key === "Account" ||
        key === "Documents" ||
        key === "Course Catalog" ||
        key === "About"
      ) {
        props.parentCallback("MenuBargetsClosed");
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const subItemPath = (url) => {
    if (isValidPathUrl(url)) {
      return window.open(url);
    } else {
      return url;
    }
  };

  const path = (url, name) => {
    if (isValidPathUrl(url) || name === "About") {
      return (window.location.href = url);
    } else {
      return url;
    }
  };
  return (
    <ListItem disableGutters classes={{ root: classes.ListItemRoot }}>
      <Link
        className={
          props.view === "mobile" ? classes.mobilelistItem : classes.listItem
        }
        aria-controls={`sub-menu-id-${props.id}`}
        // style={styles}
        onClick={(event) => handleClick(event, props.name, props.url)}
        to={props.url}
        style={{
          display: props.display ? props.display : "block",
          marginBottom: props.view === "mobile" ? "12px" : "",
        }}
      >
        {props.name}
      </Link>
      <Popper
        id={`sub-menu-id-${props.id}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transition
        disablePortal
        style={{ zIndex: 99 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id={`sub-menu-id-${props.id}`}
                  style={{
                    width: "max-content",
                    display: "inline-grid",
                  }}
                >
                  {props.view === "desktop" && props.hasSubmenu
                    ? props.subMenuItems.map((subItems, subIndex) => {
                        return (
                          <MenuItem
                            // onClick={handleClose}
                            key={subIndex}
                            onClick={() => {
                              setAnchorEl(null);
                              props.history.push(subItemPath(subItems.url));
                            }}
                            style={{
                              display: subItems.display
                                ? subItems.display
                                : "block",
                            }}
                          >
                            {subItems.name}
                          </MenuItem>
                        );
                      })
                    : null}
                  {props.view === "mobile" && props.hasSubmenu
                    ? props.subMenuItems.map((subItems, subIndex) => {
                        return (
                          <MenuItem
                            className={classes.sublistItem}
                            key={subIndex}
                            onClick={() => {
                              setAnchorEl(null);
                              props.history.push(subItemPath(subItems.url));
                              props.parentCallback("MenuBargetsClosed");
                            }}
                            style={{
                              display: subItems.display
                                ? subItems.display
                                : "block",
                              minHeight: "15px",
                              fontSize: "13px",
                            }}
                          >
                            {subItems.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </ListItem>
  );
};

export default MenuItems;
